import { ButtonHTMLAttributes } from 'react';
import styled from 'styled-components';

export interface DNSlideTabItemType<T> {
  key: number;
  label: string;
  value: T;
}

export interface DNSlideTabItemProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
  isActive: boolean;
}

const DNSlideTabItem = ({ label, isActive, ...props }: DNSlideTabItemProps) => {
  return (
    <StyledTabItem {...props} className={isActive ? 'DNSlideTabItem_selected' : 'DNSlideTabItem'} isActive={isActive}>
      <Label isActive={isActive}>{label}</Label>
    </StyledTabItem>
  );
};

export default DNSlideTabItem;

const StyledTabItem = styled.button<{ isActive: boolean }>`
  position: relative;
  padding: 8px 0 6px;
  z-index: 1;
  white-space: nowrap;

  ${({ theme, isActive }) => `
    border-bottom: 2px solid ${isActive ? `${theme.color.gray800}` : 'transparent'}
  `};
`;

const Label = styled.span<{ isActive: boolean }>`
  padding: 4px 8px;
  border-radius: 8px;

  ${({ theme, isActive }) => `
    ${isActive ? theme.typography.UI15SB : theme.typography.UI15M};
    color: ${isActive ? theme.color.gray800 : theme.color.gray400};

    &: active {
      background: ${theme.color.gray50};
    }
  `};
`;
